import * as React from "react";

import moment from "moment";
import DataTable from "react-data-table-component-with-filter";
import { RiLoopLeftFill, RiEyeLine, RiFilterLine } from "react-icons/ri";
import { NavLink, useNavigate } from "react-router-dom";

import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import fr from "dayjs/locale/fr";

import Paper from "../../Components/Paper";
import { config } from "./Helper";
import FilterComponent from "../../Components/FilterComponent";
import Button from "../../Components/Button";

import axiosInstance from "../../Api/Axios";
import { useConnectedUser } from "../../Context/ConnectedUserContext";
import { useLoader } from "../../Context/LoaderContext";

import { handleDownload } from "../../Functions/Utils";

import Logo from "./../../Images/logo.png";
import "./InvoiceEditing.scss";
/************** Data */

/********************************** Theme */
const customStyles = {
  headCells: {
    style: {
      color: "#fff",
      fontSize: "16px",
      fontWeight: "500",
      background: "#e75043",
      paddingBottom: "12px",
      paddingTop: "4px",
    },
  },
  cells: {
    style: {
      color: "#000",
      fontSize: "15px",
    },
  },
};

const InvoiceEditing = () => {
  const navigate = useNavigate();
  const onView = (id) => {
    navigate(`/details-contract/${id}`);
  };
  const [dataContract, setDataContract] = React.useState([]);
  const [filterText, setFilterText] = React.useState("");
  const [startDateValue, setStartDateValue] = React.useState(null);
  const [endDateValue, setEndDateValue] = React.useState(null);
  const [withFilter, setWithFilter] = React.useState(false);
  const { user } = useConnectedUser();

  const { setIsLoading } = useLoader();

  React.useEffect(() => {
    setIsLoading(true);
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/get-invoice-editing`)
      .then((response) => {
        setIsLoading(false);
        setDataContract(response.data.data.contracts || []);
      })
      .catch(() => {
        setIsLoading(false);
      });
  }, [setIsLoading]);

  const filteredItems = React.useMemo(() => {
    const startDateMoment = moment(startDateValue?.$d, "DD/MM/YYYY").valueOf();
    const endDateMoment = moment(endDateValue?.$d, "DD/MM/YYYY").valueOf();
    return dataContract.filter((item) => {
      return (
        JSON.stringify(item).toLowerCase().indexOf(filterText.toLowerCase()) !==
          -1 &&
        (startDateValue
          ? moment(item?.due_date, "DD/MM/YYYY").valueOf() >= startDateMoment
          : true) &&
        (endDateValue
          ? moment(item?.due_date, "DD/MM/YYYY").valueOf() <= endDateMoment
          : true)
      );
    });
  }, [dataContract, filterText, startDateValue, endDateValue]);

  const subHeaderComponent = React.useMemo(() => {
    return (
      <FilterComponent
        onFilter={(e) => setFilterText(e.target.value)}
        onClear={() => setFilterText("")}
        filterText={filterText}
      />
    );
  }, [filterText]);

  const handleResetFilterTable = () => {
    setStartDateValue(null);
    setEndDateValue(null);
  };

  const handleDownloadPdf = () => {
    handleDownload("invoice_editing", "Liste-des-factures");
  };

  return (
    <Paper>
      <div className="wrap-tabs-offer">
        <h1>Liste des factures</h1>

        <div className="daterange-filter">
          <div className="subtitle-date">Date échéance entre</div>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={fr}>
            <DemoContainer components={["DatePicker", "DatePicker"]}>
              <DatePicker
                label="DD/MM/YYYY"
                format="DD/MM/YYYY"
                value={startDateValue}
                onChange={(newValueStart) => setStartDateValue(newValueStart)}
                slotProps={{
                  field: {
                    clearable: true,
                  },
                }}
              />
              <div className="subtitle-date">et</div>
              <DatePicker
                label="DD/MM/YYYY"
                format="DD/MM/YYYY"
                value={endDateValue}
                onChange={(newValueEnd) => setEndDateValue(newValueEnd)}
                slotProps={{
                  field: {
                    clearable: true,
                  },
                }}
              />
            </DemoContainer>
          </LocalizationProvider>

          {/* <button onClick={handleFilterTable}> Filter </button> */}
          <span onClick={handleResetFilterTable} className="reset-filter">
            <RiLoopLeftFill />
          </span>
        </div>
        <div className="wrap-links-contracts">
          <NavLink to="/global-situation" className="link-contract-table">
            <span className="icon-link">
              <RiEyeLine />
            </span>
            <span className="name-link">Consulter situation globale</span>
          </NavLink>

          <NavLink to="/outstandings" className="link-contract-table">
            <span className="icon-link">
              <RiEyeLine />
            </span>
            <span className="name-link">
              Consulter l'état des financements en cours
            </span>
          </NavLink>
        </div>
        {dataContract.length > 0 && (
          <div className="wrap-btn-action wrap-btn-global-cituation">
            <Button variant="dark" view="outline" onClick={handleDownloadPdf}>
              Imprimer
            </Button>
            <Button
              onClick={() => setWithFilter((prev) => !prev)}
              variant="dark"
              view="outline"
            >
              {withFilter ? "Masquer filtre" : "Afficher filtre"}
              <RiFilterLine />
            </Button>
          </div>
        )}
        <div className="print-container">
          <div className="entete-print ">
            <table cellPadding={10}>
              <tr>
                <td className="text-center">
                  {" "}
                  <img
                    src={Logo}
                    alt="Attijari Leasing Tunisie, Crédit Leasing Tunisie | Attijari"
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <div>
                    <b>{user.name}</b>{" "}
                  </div>
                </td>
              </tr>
            </table>
          </div>
          <DataTable
            // title="Loyer du mois à payer"
            columns={config(onView, withFilter)}
            data={filteredItems}
            customStyles={customStyles}
            pagination
            subHeader
            highlightOnHover
            subHeaderComponent={subHeaderComponent}
            noDataComponent={<div> Pas d'informations disponibles</div>}
            paginationComponentOptions={{
              rowsPerPageText: "Lignes par page:",
              rangeSeparatorText: "de",
              noRowsPerPage: false,
              selectAllRowsItem: true,
              selectAllRowsItemText: "Tous",
            }}
          />
        </div>
      </div>
    </Paper>
  );
};

export default InvoiceEditing;
